export default "Navigation components allow the user to navigate through the application."